'use client';

import { useGlobalUI } from 'contexts/GlobalUIContext';
import {
  AnimatedTextSection,
  CollectionAnimatedSection,
  ColorCatalogueSection,
  HeroSection,
  HealthTracker,
  Footer,
  faqData,
  StoresSection,
  TechnicalSpecificationsRare,
  ExpertSection,
  FAQSection,
} from 'components/rare';
import { MainStyled } from 'components/rare/StyleConstants';
import {
  BENEFITS_CONTENT,
  SOPHISTICATION_CONTENT,
} from 'components/rare/constants';

const Rare = () => {
  useGlobalUI({
    footerDisabled: true,
  });

  return (
    <MainStyled
      style={{
        background: '#111111',
        color: '#ffffff',
      }}
    >
      <HeroSection />
      <CollectionAnimatedSection />
      <ColorCatalogueSection />
      <ExpertSection />
      <AnimatedTextSection />
      <HealthTracker content={SOPHISTICATION_CONTENT} />
      <TechnicalSpecificationsRare />
      <StoresSection />
      <HealthTracker
        content={BENEFITS_CONTENT}
        fullBg
        id={'rare-uhx-benefits'}
      />
      <FAQSection faqData={faqData} />
      <Footer />
    </MainStyled>
  );
};

export default Rare;
